export default (userResponse, goodResponse) => {
  const isCorrect = []
  for (const index in userResponse) {
    isCorrect[index] = goodResponse.includes(userResponse[index])
  }

  return isCorrect
}